import { CustomEventLimitForm } from './CustomEventLimitForm';
// import { UserProfileLimitForm } from './UserProfileLimitForm';
import { StyledTitle, StyledFormHeader } from '../Styled';

export const InternalTools = () => {
  return (
    <div>
      <StyledTitle>Internal Tools</StyledTitle>
      <StyledFormHeader>Update Custom Event Limit</StyledFormHeader>
      <CustomEventLimitForm />
      {/* TODO: Wire up the User Profile Limit once endpoint is completed */}
      {/* <StyledFormHeader>Update User Profile Limit (WIP)</StyledFormHeader> */}
      {/* <UserProfileLimitForm /> */}
    </div>
  );
};
